import React from 'react'
import { connect } from 'react-redux';

import EntitlementForm from './EntitlementForm';
import { loadEntitlements } from '../../actions/entitlements';

class Entitlements extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, user } = this.props;

    dispatch(loadEntitlements(this.props.user));
  }

  render() {
    return (
      <div className="border rounded-md overflow-hidden p-5 mb-6 shadow">
        <h3 className="font-bold col-span-6 mb-5">
          Entitlements
        </h3>

        <EntitlementForm user={this.props.user} />

        <div>
          <h4 className="font-bold">Existing</h4>
          {
            this.props.entitlements.length == 0 &&
              <div>No entitlements so far</div>
          }
          { this.props.entitlements.data.map((e) => (
            <div key={e.feature_key} className="grid grid-cols-3 my-2 text-xs">
              <div className="inline-block">
                {e.domain}
              </div>
              <div className="inline-block">
                {e.feature_key }
              </div>
              <input
                type="text"
                value={ e.feature_value}
                readOnly
                disabled={true}
                className="inline-block border p-2" />
            </div>
          )) }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return({
    entitlements: state.entitlements,
  });
}

export default connect(mapStateToProps)(Entitlements);
